import { render } from "./LoginFormComponent.vue?vue&type=template&id=46877d62&scoped=true&ts=true"
import script from "./LoginFormComponent.vue?vue&type=script&lang=ts"
export * from "./LoginFormComponent.vue?vue&type=script&lang=ts"

import "./LoginFormComponent.vue?vue&type=style&index=0&id=46877d62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46877d62"]])

export default __exports__